module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABUklEQVQ4jZWTvy9DURiGn6qhSQcDk80kEgPhH5BYDP4AQzv5lVuacCchDAaLom16K4qdQRMxGQ2mNukgMRotLCKhpOeV0/TGVU1cb/Lmnu/c7zw57813IwCu60aBBWAd6AFWMplMiRDqsi2CvKAg6BfEBcVV1x0MD5CSkgg4KikVBtDdAsQ7vBv6xw14lJpP33WJ/H8i3LZFmMoe7F+GBhjpwkgEPBrm8DcAlQ16NoiW15x0ujc0wMvl3iTtBiL0SdoLDbCSUVZGDzKi5eRiainxFyASLOad1CRwHdivA9PAPTALvNsLH3mFl44AqznH2QY2AlsN4BOIteo7YKLkeU8/IvgyYsuIc6Pm2jpqRCxQDxtx/Osb+DopekZSQtJZ22wEbWN1BlidHhY/JGYkNiUabVNqfeX32t+4o2rVivXNyNh4GbAzMQC8AjvAcq1aMQBfZK/t/eBc1icAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/health/information_phone_leave.png
// module id = dcC6
// module chunks = 4